import { Text, Image } from "@fluentui/react-components";
import { errorConstants } from "../../../utility/app-constants";
import { ErrorScreen } from "../../../assets";

/**
 * Error Screen for Todo and Recommended Shelf
 * @returns 
 */
export default function ComponentErrorScreen () {
    return(
        <div className="component-error-screen-main">
            <div className="component-error-screen-container">
                <Image className="component-error-screen-image" src={ErrorScreen}/>
                <Text weight="semibold">{errorConstants.errorTextTitle}</Text>
                <Text weight="semibold">{errorConstants.errorTextSubtitle}</Text>
            </div>
        </div>
    )
}